import styled from 'styled-components'

export const Section = styled.div`
  padding: 24px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  box-shadow: 0px 4px 8px 0px #00000014;
`

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  div {
    font-size: 18px;
    font-weight: 700;
    color: #213f68;
  }
  span {
    font-weight: 400;
    border: 1px solid #b6dbfb;
    background: #e7f3fe;
    border-radius: 8px;
    padding: 2px 4px;
    color: #363636;
    font-size: 12px;
    white-space: nowrap;
    margin-left: 16px;
    height: 24px;
    margin-top: 2px;
  }
`

export const SectionDescription = styled.div`
  color: #363636;
  margin-top: 16px;
`
